"use client";

import {
  Cloud,
  Database,
  GitBranch,
  Landmark,
  Lightbulb,
  Map,
  Network,
  RefreshCw,
  Server,
  Shield,
  ShieldCheck,
  Smartphone,
  Target,
  TrendingUp,
  Users,
  type LucideIcon,
} from "lucide-react";
import { cn } from "@/lib/utils";

const LUCIDE_ICONS: Record<string, LucideIcon> = {
  target: Target,
  users: Users,
  "git-branch": GitBranch,
  lightbulb: Lightbulb,
  "trending-up": TrendingUp,
  server: Server,
  "refresh-cw": RefreshCw,
  map: Map,
  network: Network,
  "shield-check": ShieldCheck,
  database: Database,
  shield: Shield,
  landmark: Landmark,
  cloud: Cloud,
  smartphone: Smartphone,
};

type SkillIconProps = {
  icon: string;
  name: string;
  size?: number;
  className?: string;
};

export function SkillIcon({ icon, name, size = 20, className }: SkillIconProps) {
  if (icon.startsWith("lucide:")) {
    const lucideName = icon.replace("lucide:", "");
    const Icon = LUCIDE_ICONS[lucideName];

    if (Icon) {
      return (
        <Icon
          aria-hidden
          size={size}
          className={cn(
            "text-foreground/50 transition-colors duration-500 group-hover:text-foreground",
            className,
          )}
        />
      );
    }
  }

  const slug = icon.startsWith("lucide:") ? "circle" : icon;
  const src = `https://cdn.simpleicons.org/${slug}/171717`;

  return (
    <img
      src={src}
      alt={name}
      width={size}
      height={size}
      className={cn(
        "opacity-50 transition-opacity duration-500 group-hover:opacity-100 dark:invert",
        className,
      )}
    />
  );
}
